var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11,
    fill: "#C2C2C2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1557,
    height: 2667,
    transform: "matrix(1 0 0 -1 -1474 1782)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5.5,
    y: -6.5,
    width: 24,
    height: 24,
    rx: 4.5,
    stroke: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5254 2.16837C11.3421 1.74404 11.0779 1.35953 10.7475 1.03634C10.4168 0.712186 10.0269 0.454587 9.59902 0.277549C9.15534 0.0932423 8.67947 -0.00109619 8.19902 9.60979e-06C7.525 9.60979e-06 6.86738 0.18458 6.2959 0.533213C6.15918 0.616611 6.0293 0.708213 5.90625 0.808017C5.7832 0.708213 5.65332 0.616611 5.5166 0.533213C4.94512 0.18458 4.2875 9.60979e-06 3.61348 9.60979e-06C3.12813 9.60979e-06 2.65781 0.0929784 2.21348 0.277549C1.78418 0.455283 1.39727 0.710947 1.06504 1.03634C0.734175 1.35916 0.469872 1.74377 0.287109 2.16837C0.0970703 2.60997 0 3.07892 0 3.56153C0 4.01681 0.0929688 4.49122 0.277539 4.97384C0.432031 5.37716 0.653516 5.79552 0.936524 6.21798C1.38496 6.88653 2.00156 7.5838 2.76719 8.29063C4.03594 9.46231 5.29238 10.2717 5.3457 10.3045L5.66973 10.5123C5.81328 10.6039 5.99785 10.6039 6.14141 10.5123L6.46543 10.3045C6.51875 10.2703 7.77383 9.46231 9.04395 8.29063C9.80957 7.5838 10.4262 6.88653 10.8746 6.21798C11.1576 5.79552 11.3805 5.37716 11.5336 4.97384C11.7182 4.49122 11.8111 4.01681 11.8111 3.56153C11.8125 3.07892 11.7154 2.60997 11.5254 2.16837V2.16837Z",
    fill: "#E45803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5254 2.16837C11.3421 1.74404 11.0779 1.35953 10.7475 1.03634C10.4168 0.712186 10.0269 0.454587 9.59902 0.277549C9.15534 0.0932423 8.67947 -0.00109619 8.19902 9.60979e-06C7.525 9.60979e-06 6.86738 0.18458 6.2959 0.533213C6.15918 0.616611 6.0293 0.708213 5.90625 0.808017C5.7832 0.708213 5.65332 0.616611 5.5166 0.533213C4.94512 0.18458 4.2875 9.60979e-06 3.61348 9.60979e-06C3.12813 9.60979e-06 2.65781 0.0929784 2.21348 0.277549C1.78418 0.455283 1.39727 0.710947 1.06504 1.03634C0.734175 1.35916 0.469872 1.74377 0.287109 2.16837C0.0970703 2.60997 0 3.07892 0 3.56153C0 4.01681 0.0929688 4.49122 0.277539 4.97384C0.432031 5.37716 0.653516 5.79552 0.936524 6.21798C1.38496 6.88653 2.00156 7.5838 2.76719 8.29063C4.03594 9.46231 5.29238 10.2717 5.3457 10.3045L5.66973 10.5123C5.81328 10.6039 5.99785 10.6039 6.14141 10.5123L6.46543 10.3045C6.51875 10.2703 7.77383 9.46231 9.04395 8.29063C9.80957 7.5838 10.4262 6.88653 10.8746 6.21798C11.1576 5.79552 11.3805 5.37716 11.5336 4.97384C11.7182 4.49122 11.8111 4.01681 11.8111 3.56153C11.8125 3.07892 11.7154 2.60997 11.5254 2.16837V2.16837Z",
    fill: "#E45803"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1557,
    height: 2667,
    fill: "white",
    transform: "matrix(1 0 0 -1 -1474 1782)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.8ecade8eaa5f3a388038912148c991ba.svg";
export { ForwardRef as ReactComponent };